import { AxiosError } from 'axios'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { LastSelectedOrgPayload, LastSelectedOrgErrorPayload } from '../../types'
import { apiClient } from '../../client'

/**
 * GET RS v1 /userSettings/lastSelectedOrg: useGetUserLastSelectedOrg
 */
export const useGetUserLastSelectedOrg = (headers?: Record<string, string>, enabled: boolean = true) => {
  return useQuery<
    LastSelectedOrgPayload, // what queryFn returns
    AxiosError<LastSelectedOrgErrorPayload>, // typed error with 404 error payload
    LastSelectedOrgPayload, // same as queryFn return type
    ['lastSelectedOrg'] // QueryKey
  >({
    queryKey: ['lastSelectedOrg'],
    queryFn: async () => {
      const response = await apiClient.get<LastSelectedOrgPayload>('/userSettings/lastSelectedOrg', { headers })
      return response.data
    },
    enabled,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      return error.response?.status !== 404 && failureCount < 3
    },
  })
}

/**
 * PUT RS v1 /userSettings/lastSelectedOrg: usePutUserLastSelectedOrg
 */

export const usePutUserLastSelectedOrg = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: LastSelectedOrgPayload) => {
      const response = await apiClient.put<LastSelectedOrgPayload>('/userSettings/lastSelectedOrg', data)
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lastSelectedOrg'] })
    },
  })
}
